import React from 'react'
import { MdOutlineHistory, MdOutlineWarningAmber } from 'react-icons/md'
import CircleLoading from '../../components/CircleLoading'
import Button from '../../components/Form/Button'
import styles from './whatsAppIntegration.module.css'

export default function CostEstimateStatus({ loading, error, progress, retry, stats, periodDays, noInboxSelected = false }) {
    if (loading) return <div className={styles.estimateState} role="status" aria-live="polite" aria-busy="true">
        <CircleLoading />
        <strong>Carregando seu histórico de mensagens</strong>
        <p>Estamos analisando as caixas de entrada e as janelas de atendimento. Os resultados aparecerão quando o cálculo estiver completo.</p>
        {progress?.processed_messages > 0 && <small>{progress.processed_messages.toLocaleString('pt-BR')} mensagens analisadas · {progress.completed_inboxes} de {progress.total_inboxes} caixas concluídas</small>}
    </div>
    if (error) return <div className={styles.estimateState} role="alert">
        <MdOutlineWarningAmber />
        <strong>Não foi possível carregar a estimativa</strong>
        <p>{error}</p>
        <Button fullWidth={false} onClick={retry}>Tentar novamente</Button>
    </div>
    const empty = stats && Number(stats.sent_messages || 0) === 0
    if (empty) return <div className={styles.estimateEmpty} role="status" aria-live="polite">
        <MdOutlineHistory />
        <div>
            <strong>{noInboxSelected ? 'Selecione uma caixa de entrada' : 'Nenhuma mensagem enviada no período'}</strong>
            <p>{noInboxSelected
                ? 'Escolha pelo menos uma caixa no filtro acima para consultar o histórico.'
                : `Não encontramos mensagens com envio confirmado nas caixas selecionadas${periodDays ? ` nos últimos ${periodDays} dias` : ' neste período'}. Experimente ampliar o período ou selecionar outras caixas de entrada.`}</p>
            <small>Você ainda pode simular disparos preenchendo os campos abaixo.</small>
        </div>
    </div>
    return null
}
